module.exports = __webpack_public_path__ + "static/media/overview_supporting@3x.46abab7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/footage/others/overview_supporting@3x.png
// module id = 569
// module chunks = 0